export default __webpack_public_path__ + "static/media/img-0240-australia-full-face.3f87825f.png";